(function() {
    'use strict';

    angular
        .module('elogbooks.user.spillages')
        .controller('UserSpillagesDetailsController', UserSpillagesDetailsController);

    UserSpillagesDetailsController.$inject = ['spillageResponse', 'modulesService'];

    function UserSpillagesDetailsController(spillageResponse, modulesService) {
        var vm = this;
        vm.spillage = spillageResponse;
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
    }
})();